import type { ApiErrorResponse } from './types';

/** Base error class for AstraSync SDK errors. */
export class AstraSyncError extends Error {
  public readonly code?: string;
  public readonly statusCode: number;

  constructor(message: string, statusCode: number, code?: string) {
    super(message);
    this.name = 'AstraSyncError';
    this.statusCode = statusCode;
    this.code = code;
  }
}

/** Thrown when KYD verification is required before agent registration. */
export class KYDRequiredError extends AstraSyncError {
  public readonly kydUrl: string;
  public readonly ownerNotified: boolean;

  constructor(response: ApiErrorResponse) {
    const kydUrl = response.kydUrl || 'https://app.kya.astrasync.ai/developer-profile';
    super(
      `KYD verification required before registering agents.\nComplete your KYD profile at: ${kydUrl}`,
      403,
      'KYD_REQUIRED',
    );
    this.name = 'KYDRequiredError';
    this.kydUrl = kydUrl;
    this.ownerNotified = response.ownerNotified || false;
  }
}

/** Thrown when authentication fails. */
export class AuthenticationError extends AstraSyncError {
  constructor(message: string) {
    super(message, 401, 'AUTH_FAILED');
    this.name = 'AuthenticationError';
  }
}
